import React from "react";
import { ArrowUpIcon } from "../../../../common/components/MaxMinArrows";
import ThroughputChartNoResults from "../common/throughput-chart-noresults-component";
import { processMonthlyData, calculateAverageImprovement } from "../../../../utils/process-monthly-data-util";
import "./AverageMonthlyPerformance.scss";

function AverageMonthlyImprovement({ throughputHistory }) {
    const { networkData, subscriptionData, isLoading, isSuccess } = throughputHistory;

    //Processing and formatting results
    const { networkDownlink, subscriptionDownlink } = processMonthlyData(subscriptionData, networkData);
    const averageData = calculateAverageImprovement(networkDownlink, subscriptionDownlink);

    //rendering
    return (
        <div className="performance-card">
            {/* When the downlink values are null or an error occurred while fetching data*/}
            {!isLoading && networkDownlink === null && subscriptionDownlink === null && (
                <>
                    <h2 className="performance-card-title"> Average Improvement</h2>
                    <ThroughputChartNoResults />
                </>
            )}

            {/* When data is still loading*/}
            {isLoading && !isSuccess && (
                <>
                    <h2 className="performance-card-title"> Average Improvement</h2>
                    <div className="performance-with-lanes-value">loading...</div>
                    <div className="performance-without-lanes-value">Last 30 Days with LANES</div>
                </>
            )}

            {/* When data is done loading and the downlink values are available */}
            {!isLoading && isSuccess && networkDownlink !== null && subscriptionDownlink !== null && (
                <>
                    <h2 className="performance-card-title"> Average Improvement</h2>
                    <div className="performance-with-lanes-value">
                        <span className="performance-arrow-icon">
                            <ArrowUpIcon developmentUrl="/assets/able-sprites.svg" />
                        </span>
                        {`${averageData}%`}
                    </div>
                    <div className="performance-without-lanes-value">Last 30 Days with LANES</div>
                </>
            )}
        </div>
    );
}

export default AverageMonthlyImprovement;
